import styled from 'styled-components';

export const FlexContainer = styled.div.attrs({
  className: 'FlexContainer',
  width: props => props.width,
  maxwidth: props => props.maxwidth,
  height: props => props.height,
  direction: props => props.direction,
  justifycontent: props => props.justifycontent,
  alignitems: props => props.alignitems,
  family: props => props.family,
  size: props => props.size,
  weight: props => props.weight,
  lineheight: props => props.lineheight,
  // color: props => props.color,
  borderradius: props => props.borderradius,
  background: props => props.background,
  margin: props => props.margin
})`
  display: flex;
  width: ${props => props.width};
  max-width: ${props => props.maxwidth};
  height: ${props => props.height};
  flex-direction: ${props => props.direction};
  justify-content: ${props => props.justifycontent};
  align-items: ${props => props.alignitems};
  font-family: ${props => props.family};
  font-size: ${props => props.size};
  font-weight: ${props => props.weight};
  line-height: ${props => props.lineheight};
  border-radius: ${props => props.borderradius};
  background: ${props =>
    props.background ? `${props.background} !important` : null};
  margin: ${props => props.margin};
  /* a {
    text-decoration: none;
    color: ${props => props.color};
  } */
`;
